import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Pdf"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 8.25V6.75H16.5V17.25H18V12.75H21.75V11.25H18V8.25H22.5ZM6 6.75H1.5V17.25H3V13.5H6C6.82843 13.5 7.5 12.8284 7.5 12V8.25C7.5 7.42157 6.82843 6.75 6 6.75ZM6 12H3V8.25H6V12ZM12 17.25H9V6.75H12C13.6569 6.75 15 8.09315 15 9.75V14.25C15 15.9069 13.6569 17.25 12 17.25ZM10.5 15.75H12C12.8284 15.75 13.5 15.0784 13.5 14.25V9.75C13.5 8.92157 12.8284 8.25 12 8.25H10.5V15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Pdf.vue"]]);
